<template>
  <div class="xliarticle-list">
    <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";

export default {
  name: "xliarticle-list",
  data() {
    return {
      title: "献礼评论",
      loading: true,
      dataloading: true,
      articledata: {
        status: "0"
      },
      columns: [
        {
          title: "Id",
          key: "id",
          width: 100
        },
        {
          title: "用户",
          key: "name",
          width: 300
        },
        {
          title: "内容",
          key: "content",
          width: 450
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      showStatus: false
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    this.articleid = this.$route.params.id;
    // 取数据
    this.getTableList();
  },
  components: {},
  methods: {
    getTableList: function() {
      var ps = {
        articleid: this.articleid,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.xliarticle.commentlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        articleid: this.articleid,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.xliarticle.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.xliarticle.removecomment({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>
